import client from './client';
import { LoginHistory, ProductHistory, OrderHistory } from '../types';

export const getLoginHistory = async (): Promise<LoginHistory[]> => {
  const { data } = await client.get('/history/login');
  return data;
};

export const getProductHistory = async (productId: string): Promise<ProductHistory[]> => {
  const { data } = await client.get(`/history/product/${productId}`);
  return data;
};

export const getOrderHistory = async (orderId: string): Promise<OrderHistory[]> => {
  const { data } = await client.get(`/history/order/${orderId}`);
  return data;
};

export const getOrderHistories = async (
  orderIds: string[],
): Promise<Record<string, OrderHistory[]>> => {
  if (orderIds.length === 0) {
    return {};
  }

  const { data } = await client.get('/history/orders/batch', {
    params: {
      orderIds: orderIds.join(','),
    },
  });
  return data;
};

export const getProductsHistory = async (search?: string): Promise<ProductHistory[]> => {
  const { data } = await client.get('/history/products', { params: { search } });
  return data;
};

export const getOrdersHistory = async (search?: string): Promise<OrderHistory[]> => {
  const { data } = await client.get('/history/orders', { params: { search } });
  return data;
};
